if(!customElements.get('collection-grid')) {
  class CollectionGrid extends HTMLElement {
    static observedAttributes = [
      "loading",
      "filters-active",
      "product-count",
      "page-current",
      "page-total",
      "page-next"
    ];

    constructor() {
      super();

      this.elFeed = this.querySelector('[data-feed]');
      this.elEmpty = this.querySelector('[data-empty]');
      this.elProducts = this.querySelector('[data-products]');
      this.elFilters = this.querySelector('collection-filters');
      this.elObserve = this.querySelector('[data-observer]');

      this.observer = this.elObserver ? new IntersectionObserver(this.paginateCollection.bind(this)).observe(this.elObserver) : null;
    }

    attributeChangedCallback() {
      this.loading = this.getAttribute('loading');
      this.filtersActive = this.getAttribute('filters-active');
      this.productCount = this.getAttribute('product-count');
      this.pageCurrent = this.getAttribute('page-current');
      this.pageTotal = Number(this.getAttribute('page-total'));
      this.pageNext = this.getAttribute('page-next');
    }

    connectedCallback() {
      const hasFilters = window.location.href.includes('?filter');
      this.setAttribute('filters-active', hasFilters);
      this.appendTemplate();
    }

    setCtaColumns() {
      const elProducts = this.querySelectorAll('[data-product]');
      const totalCount = elProducts.length;
      const columns = Number(getComputedStyle(this.elFeed).getPropertyValue('--desktop-columns'));
      const remainder = totalCount % columns;
      const ctaColumns = columns - remainder;

      this.elFeed.classList.toggle('has-cta', remainder > 0);
      this.elFeed.classList.toggle('multi-column', ctaColumns > 1)
      this.elFeed.style.setProperty('--cta-columns', ctaColumns);
    }

    appendTemplate() {
      const isEmpty = this.productCount == 0;
      const template = isEmpty ? this.elEmpty : this.elProducts;

      this.elFeed.innerHTML = '';
      this.elFeed.appendChild(template.content.cloneNode(true));
      this.setCtaColumns();

      setTimeout(() => this.setAttribute('loading', false), 300);
    }

    paginateCollection([entry], observer) {
      if (entry.isIntersecting && this.pageCurrent < this.pageTotal) {
        this.elProducts.setAttribute('aria-busy', true);
        this.setCollection(this.pageNext, true);
      }
    }

    setCollection(url, shouldAppend) {
      this.setAttribute('loading', true);
      window.history.pushState({}, '', url);

      this.loadCollection(url)
        .then(elGrid => {
          const elNewProducts = elGrid.querySelector('[data-products]');
          const hasFilters = window.location.href.includes('?filter');

          this.setAttribute('product-count', elGrid.getAttribute('product-count'));
          this.setAttribute('page-current', elGrid.getAttribute('page-current'));
          this.setAttribute('page-total', elGrid.getAttribute('page-total'));
          this.setAttribute('page-next', elGrid.getAttribute('page-next'));
          this.setAttribute('filters-active', hasFilters);

          this.elProducts.innerHTML = shouldAppend ? `${this.elProducts.html}${elNewProducts.innerHTML}` : elNewProducts.innerHTML;

          this.appendTemplate();
          window.initLazyLoad();
          this.elFilters.dispatchEvent(new CustomEvent('grid:loaded'));
        })
    }

    async loadCollection(url) {
      const response = await fetch(url);
      const data = await response.text();

      const html = new DOMParser().parseFromString(data, 'text/html');
      const elGrid = html.querySelector(`#${this.id}`);

      return elGrid;
    }
  }

  customElements.define('collection-grid', CollectionGrid);
}